<template>
	<v-app-bar
		:app="app"
		:dense="dense"
		:hide-on-scroll="hideOnScroll"
		:role="role"
		v-bind="$attrs"
		v-on="$listeners">
		<slot/>
	</v-app-bar>
</template>

<script>

export default {
	name: 'KAppBar',
	inheritAttrs: false,
	props: {
		app: {
			type: Boolean,
			default: false
		},
		dense: {
			type: Boolean,
			default: false
		},
		hideOnScroll: {
			type: Boolean,
			default: false
		},
		role: {
			type: String,
			default: undefined
		}
	}
}
</script>
